import { CreateICLeadRequest, CreateICLeadResponse } from 'types/types';
import { ReferralChannel } from './types';
import v1Api from 'api';
import api from 'api/api';

export const createMylerLead = async (payload: CreateICLeadRequest ) => {
  const {data} = await v1Api.post<CreateICLeadResponse>(`/ics/leads/`, payload);

  return data;
};


export const getReferralChannels = async ( ) => {
  const {data} = await api.get<ReferralChannel[]>(`/ics/referral-channels`);
  return data;
};
